import { useContext } from "react";
import { UserContext } from "./UserContext";

interface UserContextValue {
  user: any;

  setUser: (_user: any) => void;

  colors: string[];

  setColors: (_colors: string[]) => void;

  isLoadingUser: boolean;

  setIsLoadingUser: (_isLoading: boolean) => void;
}

/**
 * Custom hook to access user context.
 * @returns {Object} The user context
 * @returns {any} user - The current user object
 * @returns {Function} setUser - Function to set user
 * @returns {string[]} colors - Array of colors
 * @returns {Function} setColors - Function to set colors
 * @returns {boolean} isLoadingUser - Loading state
 * @returns {Function} setIsLoadingUser - Function to set loading state
 */
export function useUser(): UserContextValue {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error("useUser must be used within UserProvider");
  }

  const { user, setUser, colors, setColors, isLoadingUser, setIsLoadingUser } =
    context;
  return {
    user,
    setUser,
    colors,
    setColors,
    isLoadingUser,
    setIsLoadingUser,
  };
}
